export function fnCleanStorage() {
  // limpa tudo o que for armazenado no login
  localStorage.removeItem('cAccessToken');
  localStorage.removeItem('cStorageToken');
  sessionStorage.removeItem('nCustId');
  sessionStorage.removeItem('cOldCompanyName');
  // se você tiver outras chaves, acrescente aqui…
}
